<script>
  import { createEventDispatcher } from 'svelte';
  import { closeIcon } from './Icons';
  import { channel } from '../Chat/chat-store';

  const dispatch = createEventDispatcher();

  $: news = $channel && $channel.category === 'news';
  $: sport = $channel && $channel.category === 'sport';
  $: entertainment = $channel && $channel.category === 'entertainment';

  export let icon;
  export let backgroundColor = '#10192F';
  export let height = '200';
  export let iconMarginTop = '-90';
</script>

<div class="login-background-container" class:news class:sport class:entertainment>
  <div class="background" />
  <div
    class="ellipse"
    style={!news || !entertainment || !sport
      ? `background-color: ${backgroundColor}; height: ${height}px`
      : ''}
  />
  <div class="close-btn-container">
    <button class="close-btn" on:click={() => dispatch('close')}>
      {@html closeIcon}
    </button>
  </div>
  <div class="icon" style={`margin-top: ${iconMarginTop}px;`}>
    {#if icon}
      {@html icon}
    {/if}
  </div>
</div>

<style src="./loginBackground.scss"></style>
